import { render } from "./NuevoHola.vue?vue&type=template&id=5c549d16"
import script from "./NuevoHola.vue?vue&type=script&lang=js"
export * from "./NuevoHola.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__